<template>
    <div class="person">
        <div class="condition">
            <div class="item">
                <div class="label">时间:</div>
                <el-date-picker
                    v-model="conditionData.date"
                    type="date"
                    size="small"
                    placeholder="选择日期">
                </el-date-picker>
            </div>
            <div class="item">
                <div class="label">医保类型:</div>
                <el-input v-model="conditionData.CPlyNo" size="small" placeholder="请输入"></el-input>
            </div>
            <div class="item">
                <div class="label">药品类型:</div>
                <el-select v-model="conditionData.DcTaskActions" multiple size="small" placeholder="请选择" class="input">
                    <el-option
                    v-for="item in list"
                    :key="item"
                    :label="item"
                    :value="item">
                    </el-option>
                </el-select>
            </div>
            <div class="item">
                <div class="label">药品名称:</div>
                <el-input v-model="conditionData.CPlyNo" size="small" placeholder="请输入"></el-input>
            </div>
            <div class="btns">
                <el-button type="primary" size="small" @click="selectData()">查询</el-button>
                <el-button type="" size="small" @click="reset()">重置</el-button>
            </div>
        </div>

        <div class="table">
            <div class="handle">
                <el-button type="" icon="el-icon-refresh-left" size="small" @click="loadingData()">刷新列表</el-button>
                <div>
                </div>
            </div>
            <el-table
                :data="tableData"
                border
                :header-cell-style="tableHeaderColor"
                style="width: 100%">
                
                <el-table-column
                type="index"
                width="60"
                label="序号"
                align="center"
                >
                </el-table-column>
                <el-table-column
                prop="ypmc"
                label="药品名称"
                align="center"
                >
                </el-table-column>
                <el-table-column
                prop="tym"
                label="通用名"
                align="center"
                >
                </el-table-column>
                <el-table-column
                prop="jx"
                label="剂型"
                align="center"
                >
                </el-table-column>
                <el-table-column
                prop="yblb"
                label="医保类别"
                align="center"
                >
                </el-table-column>
                <el-table-column
                prop="ybbh"
                label="医保编号"
                align="center"
                >
                </el-table-column>
                <el-table-column
                prop="ypfl"
                label="药品分类"
                align="center"
                width="350px"
                >
                </el-table-column>
                <el-table-column
                prop="qy"
                label="区域"
                align="center"
                >
                </el-table-column>
                <el-table-column
                prop="zbqk"
                label="增补情况"
                align="center"
                >
                </el-table-column>
                <el-table-column
                prop="ybbb"
                label="医保版本"
                align="center"
                >
                </el-table-column>
                <!-- <el-table-column
                prop="zxsj"
                label="执行时间"
                align="center"
                >
                </el-table-column>
                <el-table-column
                prop="zxzt"
                label="执行状态"
                align="center"
                >
                </el-table-column>

                <el-table-column
                fixed="right"
                label="操作"
                width="200px"
                align="center"
                >
                <template slot-scope="scope">
                    <el-button type="text" icon="el-icon-edit" size="mini" @click="isUpdateDialogShow(scope.row)">编辑</el-button>
                    <el-button type="text" icon="el-icon-delete" size="mini" @click="deletePetShop(scope.row)">删除</el-button>
                </template>
                </el-table-column> -->
            </el-table>

            <div class="page">
                <el-pagination
                @current-change="handleCurrentChange"
                    background
                    layout="prev, pager, next, total"
                    :total="totalCount"
                    :current-page="conditionData.page"
                    :page-size="conditionData.pageSize">
                </el-pagination>
                
            </div>
        </div>


        
       <!-- 大图预览 -->
        <el-image-viewer
            v-if="showBigImg"
            :on-close="closeViewer"
            :url-list="showBigImgList"
            :initial-index="imgIndex"
        />
    </div>
</template>
<script>
import api from '../../../api/main'
import { regionData , CodeToText , TextToCode } from "element-china-area-data";
import ElImageViewer from 'element-ui/packages/image/src/image-viewer'
export default {
    name: 'person',
    components:{
        ElImageViewer,
    },
    watch: {
    },
    data () {
        return {
            uploadUrl:'',
            title:'',
            isShow:false,
            isAddDialog:false,
            isUpdateDialog:false,
            totalCount:0,
            conditionData:{
                petShop:'',
                page:1,
                pageSize:10,
            },
            addData:{},
            updateData:{
                petShop:'',
                contacts:'',
                phone:'',
                address:'',
                province:'',
                city:'',
                area:'',
                addressCode:'',
                projectPrices:[{
                    name: '',
                    price: '',
                }],
            },
            tableData:[

                {ypmc:'颠茄酊',tym:'颠茄',jx:'溶液剂',yblb:'甲类',ybbh:'★（33）',ypfl:'消化道和代谢方面的药物>治疗功能性胃肠道疾病的药物>单方颠茄及其衍生物(XA>XA03>XA03B>)',qy:'国家医保',zbqk:'国家医保品种',ybbb:'国家医保(2021年版）',zxsj:'2022/1/1',zxzt:'执行中'},

                {ypmc:'葛根素注射液',tym:'葛根素',jx:'注射剂',yblb:'乙类',ybbh:'312',ypfl:'心血管系统>心脏治疗药>其他心脏疾病用药(XC>XC01>XC01E)',qy:'国家医保',zbqk:'国家医保品种',ybbb:'国家医保(2021年版）',zxsj:'2022/1/1',zxzt:'执行中'},
                {ypmc:'注射用磷酸川芎嗪',tym:'川芎嗪',jx:'注射剂',yblb:'乙类',ybbh:'321',ypfl:'心血管系统>抗高血压药>外周作用的抗肾上腺素能药(XC>XC02>XC02C)',qy:'国家医保',zbqk:'国家医保品种',ybbb:'国家医保(2021年版）',zxsj:'2022/1/1',zxzt:'执行中'},
                {ypmc:'银杏达莫注射液',tym:'银杏达莫',jx:'注射剂',yblb:'乙类',ybbh:'322',ypfl:'心血管系统>抗高血压药>外周作用的抗肾上腺素能药(XC>XC02>XC02C)',qy:'国家医保',zbqk:'国家医保品种',ybbb:'国家医保(2021年版）',zxsj:'2022/1/1',zxzt:'执行中'},
                {ypmc:'银杏叶提取物注射液',tym:'银杏叶提取物',jx:'注射剂',yblb:'乙类',ybbh:'★（323）',ypfl:'心血管系统>抗高血压药>外周作用的抗肾上腺素能药(XC>XC02>XC02C)',qy:'国家医保',zbqk:'国家医保品种',ybbb:'国家医保(2021年版）',zxsj:'2022/1/1',zxzt:'执行中'},
                {ypmc:'银杏蜜环口服溶液',tym:'银杏蜜环',jx:'溶液剂',yblb:'乙类',ybbh:'324',ypfl:'心血管系统>抗高血压药>外周作用的抗肾上腺素能药(XC>XC02>XC02C)',qy:'国家医保',zbqk:'国家医保品种',ybbb:'国家医保(2021年版）',zxsj:'2022/1/1',zxzt:'执行中'},
                {ypmc:'薯蓣皂苷片',tym:'薯蓣皂苷',jx:'片剂',yblb:'乙类',ybbh:'325',ypfl:'心血管系统>抗高血压药>外周作用的抗肾上腺素能药(XC>XC02>XC02C)',qy:'国家医保',zbqk:'国家医保品种',ybbb:'国家医保(2021年版）',zxsj:'2022/1/1',zxzt:'执行中'},
                {ypmc:'注射用七叶皂苷钠',tym:'七叶皂苷',jx:'注射剂',yblb:'乙类',ybbh:'★（355）',ypfl:'心血管系统>血管保护剂(XC>XC05)',qy:'国家医保',zbqk:'国家医保品种',ybbb:'国家医保(2021年版）',zxsj:'2022/1/1',zxzt:'执行中'},
                {ypmc:'白芍总苷胶囊',tym:'白芍总苷',jx:'胶囊剂',yblb:'乙类',ybbh:'890',ypfl:'肌肉-骨骼系统药物>抗炎和抗风湿药>非甾体类抗炎和抗风湿药>其他非甾体类抗炎和抗风湿药(XM>XM01>XM01A>XM01AX)',qy:'国家医保',zbqk:'国家医保品种',ybbb:'国家医保(2021年版）',zxsj:'2022/1/1',zxzt:'执行中'},
                {ypmc:'复方甘草片',tym:'复方甘草',jx:'片剂',yblb:'甲类',ybbh:'1138',ypfl:'呼吸系统>咳嗽和感冒制剂>镇咳药与祛痰药的复方(XR>XR05>XR05F)',qy:'国家医保',zbqk:'国家医保品种',ybbb:'国家医保(2021年版）',zxsj:'2022/1/1',zxzt:'执行中'},
                {ypmc:'小儿清热感冒片',tym:'小儿清热感冒',jx:'片剂',yblb:'甲类',ybbh:'3',ypfl:'内科用药>解表剂>辛温解表剂(ZA>ZA01>ZA01A)',qy:'国家医保',zbqk:'国家医保品种',ybbb:'国家医保(2021年版）',zxsj:'2022/1/1',zxzt:'执行中'},
                {ypmc:'感冒清热颗粒',tym:'感冒清热',jx:'散剂、颗粒剂',yblb:'甲类',ybbh:'4',ypfl:'内科用药>解表剂>辛温解表剂(ZA>ZA01>ZA01A)',qy:'国家医保',zbqk:'国家医保品种',ybbb:'国家医保(2021年版）',zxsj:'2022/1/1',zxzt:'执行中'},
                {ypmc:'感冒疏风片',tym:'感冒疏风',jx:'片剂',yblb:'乙类',ybbh:'5',ypfl:'内科用药>解表剂>辛温解表剂(ZA>ZA01>ZA01A)',qy:'国家医保',zbqk:'国家医保品种',ybbb:'国家医保(2021年版）',zxsj:'2022/1/1',zxzt:'执行中'},
                {ypmc:'葛根汤片',tym:'葛根汤',jx:'片剂',yblb:'乙类',ybbh:'6',ypfl:'内科用药>解表剂>辛温解表剂(ZA>ZA01>ZA01A)',qy:'国家医保',zbqk:'国家医保品种',ybbb:'国家医保(2021年版）',zxsj:'2022/1/1',zxzt:'执行中'},
                {ypmc:'桂枝颗粒',tym:'桂枝',jx:'散剂、颗粒剂',yblb:'乙类',ybbh:'7',ypfl:'内科用药>解表剂>辛温解表剂(ZA>ZA01>ZA01A)',qy:'国家医保',zbqk:'国家医保品种',ybbb:'国家医保(2021年版）',zxsj:'2022/1/1',zxzt:'执行中'},
                {ypmc:'小儿至宝丸',tym:'小儿至宝',jx:'丸剂',yblb:'乙类',ybbh:'10',ypfl:'内科用药>解表剂>辛温解表剂(ZA>ZA01>ZA01A)',qy:'国家医保',zbqk:'国家医保品种',ybbb:'国家医保(2021年版）',zxsj:'2022/1/1',zxzt:'执行中'},
                {ypmc:'正柴胡饮合剂',tym:'正柴胡饮',jx:'溶液剂',yblb:'乙类',ybbh:'★（2）',ypfl:'内科用药>解表剂>辛温解表剂(ZA>ZA01>ZA01A)',qy:'国家医保',zbqk:'国家医保品种',ybbb:'国家医保(2021年版）',zxsj:'2022/1/1',zxzt:'执行中'},
                {ypmc:'柴银颗粒',tym:'柴银',jx:'散剂、颗粒剂',yblb:'乙类',ybbh:'19',ypfl:'内科用药>解表剂>辛凉解表剂(ZA>ZA01>ZA01B)',qy:'国家医保',zbqk:'国家医保品种',ybbb:'国家医保(2021年版）',zxsj:'2022/1/1',zxzt:'执行中'},






                {ypmc:'桑菊感冒片',tym:'桑菊感冒',jx:'片剂',yblb:'乙类',ybbh:'24',ypfl:'内科用药>解表剂>辛凉解表剂(ZA>ZA01>ZA01B)',qy:'国家医保',zbqk:'国家医保品种',ybbb:'国家医保(2021年版）',zxsj:'2022/1/1',zxzt:'执行中'},
                {ypmc:'双黄连注射液',tym:'双黄连',jx:'注射剂',yblb:'乙类',ybbh:'★（14）',ypfl:'内科用药>解表剂>辛凉解表剂(ZA>ZA01>ZA01B)',qy:'国家医保',zbqk:'国家医保品种',ybbb:'国家医保(2021年版）',zxsj:'2022/1/1',zxzt:'执行中'},
                {ypmc:'五粒回春丸',tym:'五粒回春',jx:'丸剂',yblb:'乙类',ybbh:'26',ypfl:'内科用药>解表剂>辛凉解表剂(ZA>ZA01>ZA01B)',qy:'国家医保',zbqk:'国家医保品种',ybbb:'国家医保(2021年版）',zxsj:'2022/1/1',zxzt:'执行中'},
                {ypmc:'小儿百寿丸',tym:'小儿百寿',jx:'丸剂',yblb:'乙类',ybbh:'27',ypfl:'内科用药>解表剂>辛凉解表剂(ZA>ZA01>ZA01B)',qy:'国家医保',zbqk:'国家医保品种',ybbb:'国家医保(2021年版）',zxsj:'2022/1/1',zxzt:'执行中'},
                {ypmc:'小儿热速清口服液',tym:'小儿热速清',jx:'溶液剂',yblb:'乙类',ybbh:'31',ypfl:'内科用药>解表剂>辛凉解表剂(ZA>ZA01>ZA01B)',qy:'国家医保',zbqk:'国家医保品种',ybbb:'国家医保(2021年版）',zxsj:'2022/1/1',zxzt:'执行中'},
                {ypmc:'小儿退热合剂',tym:'小儿退热',jx:'溶液剂',yblb:'乙类',ybbh:'32',ypfl:'内科用药>解表剂>辛凉解表剂(ZA>ZA01>ZA01B)',qy:'国家医保',zbqk:'国家医保品种',ybbb:'国家医保(2021年版）',zxsj:'2022/1/1',zxzt:'执行中'},
                {ypmc:'小儿退热合剂(小儿退热口服液)',tym:'小儿退热',jx:'溶液剂',yblb:'乙类',ybbh:'32',ypfl:'内科用药>解表剂>辛凉解表剂(ZA>ZA01>ZA01B)',qy:'国家医保',zbqk:'国家医保品种',ybbb:'国家医保(2021年版）',zxsj:'2022/1/1',zxzt:'执行中'},
                {ypmc:'银翘解毒软胶囊',tym:'银翘解毒',jx:'胶囊剂',yblb:'乙类',ybbh:'★（15）',ypfl:'内科用药>解表剂>辛凉解表剂(ZA>ZA01>ZA01B)',qy:'国家医保',zbqk:'国家医保品种',ybbb:'国家医保(2021年版）',zxsj:'2022/1/1',zxzt:'执行中'},
                {ypmc:'银翘解毒口服液',tym:'银翘解毒',jx:'溶液剂',yblb:'乙类',ybbh:'★（15）',ypfl:'内科用药>解表剂>辛凉解表剂(ZA>ZA01>ZA01B)',qy:'国家医保',zbqk:'国家医保品种',ybbb:'国家医保(2021年版）',zxsj:'2022/1/1',zxzt:'执行中'},
                {ypmc:'防风通圣丸(浓缩丸)',tym:'防风通圣',jx:'丸剂',yblb:'甲类',ybbh:'35',ypfl:'内科用药>解表剂>表里双解剂(ZA>ZA01>ZA01C)',qy:'国家医保',zbqk:'国家医保品种',ybbb:'国家医保(2021年版）',zxsj:'2022/1/1',zxzt:'执行中'},
                {ypmc:'小柴胡胶囊',tym:'小柴胡',jx:'胶囊剂',yblb:'甲类',ybbh:'36',ypfl:'内科用药>解表剂>表里双解剂(ZA>ZA01>ZA01C)',qy:'国家医保',zbqk:'国家医保品种',ybbb:'国家医保(2021年版）',zxsj:'2022/1/1',zxzt:'执行中'},
                {ypmc:'小柴胡汤丸',tym:'小柴胡',jx:'丸剂',yblb:'乙类',ybbh:'39',ypfl:'内科用药>解表剂>表里双解剂(ZA>ZA01>ZA01C)',qy:'国家医保',zbqk:'国家医保品种',ybbb:'国家医保(2021年版）',zxsj:'2022/1/1',zxzt:'执行中'},
                {ypmc:'小儿双解止泻颗粒',tym:'小儿双解止泻',jx:'散剂、颗粒剂',yblb:'乙类',ybbh:'43',ypfl:'内科用药>解表剂>表里双解剂(ZA>ZA01>ZA01C)',qy:'国家医保',zbqk:'国家医保品种',ybbb:'国家医保(2021年版）',zxsj:'2022/1/1',zxzt:'执行中'},
                {ypmc:'玉枢散',tym:'玉枢',jx:'散剂、颗粒剂',yblb:'乙类',ybbh:'44',ypfl:'内科用药>解表剂>表里双解剂(ZA>ZA01>ZA01C)',qy:'国家医保',zbqk:'国家医保品种',ybbb:'国家医保(2021年版）',zxsj:'2022/1/1',zxzt:'执行中'},
                {ypmc:'参苏丸(水丸)',tym:'参苏',jx:'丸剂',yblb:'乙类',ybbh:'47',ypfl:'内科用药>解表剂>扶正解表剂(ZA>ZA01>ZA01D)',qy:'国家医保',zbqk:'国家医保品种',ybbb:'国家医保(2021年版）',zxsj:'2022/1/1',zxzt:'执行中'},
                {ypmc:'保济口服液',tym:'保济',jx:'溶液剂',yblb:'甲类',ybbh:'48',ypfl:'内科用药>祛暑剂>解表祛暑剂(ZA>ZA02>ZA02A)',qy:'国家医保',zbqk:'国家医保品种',ybbb:'国家医保(2021年版）',zxsj:'2022/1/1',zxzt:'执行中'},
                {ypmc:'复方香薷水',tym:'复方香薷水',jx:'溶液剂',yblb:'乙类',ybbh:'50',ypfl:'内科用药>祛暑剂>解表祛暑剂(ZA>ZA02>ZA02A)',qy:'国家医保',zbqk:'国家医保品种',ybbb:'国家医保(2021年版）',zxsj:'2022/1/1',zxzt:'执行中'},
                {ypmc:'十滴水',tym:'十滴水',jx:'溶液剂',yblb:'甲类',ybbh:'51',ypfl:'内科用药>祛暑剂>清热祛暑剂(ZA>ZA02>ZA02B)',qy:'国家医保',zbqk:'国家医保品种',ybbb:'国家医保(2021年版）',zxsj:'2022/1/1',zxzt:'执行中'},
                {ypmc:'紫金散',tym:'紫金',jx:'散剂、颗粒剂',yblb:'乙类',ybbh:'57',ypfl:'内科用药>祛暑剂>健胃祛暑剂(ZA>ZA02>ZA02C)',qy:'国家医保',zbqk:'国家医保品种',ybbb:'国家医保(2021年版）',zxsj:'2022/1/1',zxzt:'执行中'},
                {ypmc:'三黄片',tym:'三黄',jx:'片剂',yblb:'甲类',ybbh:'58',ypfl:'内科用药>泻下剂>泻火通便剂(ZA>ZA03>ZA03A)',qy:'国家医保',zbqk:'国家医保品种',ybbb:'国家医保(2021年版）',zxsj:'2022/1/1',zxzt:'执行中'},
                {ypmc:'大黄通便胶囊',tym:'大黄通便',jx:'胶囊剂',yblb:'乙类',ybbh:'59',ypfl:'内科用药>泻下剂>泻火通便剂(ZA>ZA03>ZA03A)',qy:'国家医保',zbqk:'国家医保品种',ybbb:'国家医保(2021年版）',zxsj:'2022/1/1',zxzt:'执行中'},
                {ypmc:'通便灵胶囊',tym:'通便灵',jx:'胶囊剂',yblb:'乙类',ybbh:'61',ypfl:'内科用药>泻下剂>泻火通便剂(ZA>ZA03>ZA03A)',qy:'国家医保',zbqk:'国家医保品种',ybbb:'国家医保(2021年版）',zxsj:'2022/1/1',zxzt:'执行中'},
            ],

            addressList:[],
            options:regionData,
            picList1:[],
            picList2:[],
            picList3:[],
            showBigImg:false,
            showBigImgList:[],
            imgIndex:0,

            list:[
                '化学药','生物制品','中成药','中药饮片'
            ],
        }
    },
    created(){
        

    },
    mounted(){
        // this.loadingData();
    },
    methods:{

        async addImg1(file){
            let res = await api.uploadOther(file.file);
            this.picList1.push(res);
        },
        async addImg2(file){
            let res = await api.uploadOther(file.file);
            this.picList2.push(res);
        },
        async addImg3(file){
            let res = await api.uploadOther(file.file);
            this.picList3.push(res);

        },
        // 图片查看
        closeViewer(){
            this.showBigImg = false;
        },
        previewImg(index,piclist){
            this.imgIndex = index
            this.showBigImgList = piclist;
            this.showBigImg = true;
        },
        clearImg(index,type){
            if(type==1){
                this.picList1.splice(index,1)
            }else if(type==2){
                this.picList2.splice(index,1)
            }else if(type==3){
                this.picList3.splice(index,1)
            }
        },
        tableHeaderColor ({ row, column, rowIndex, columnIndex }) {
            if (rowIndex === 0) {
                return 'background-color: #F2F2F2;color: #000;'
            }
        },
        async loadingData() {
            let res  = await api.collectPetQueryPager(this.conditionData);
            console.log(res);
            this.tableData = res.data.data.data;
            this.totalCount = res.data.data.totalCount;
        },
        selectData(){
            this.conditionData.page = 1;
            // this.loadingData();
        },
        reset(){
            this.conditionData = {
                // name:'',
                page:1,
                pageSize:10,
            };
            // this.loadingData();
        },
        handleCurrentChange(page){
            this.conditionData.page = page;
            this.loadingData();
        },
        showAddDialog(){
            this.title = '新增';
            this.isShow = true;
            this.isAddDialog = true;
        },
       
        async addRole(){
            let res  = await api.CreateRole(this.addData);
            console.log(res);
            if(res.data.code == '200') {
                this.$message({
                    message: '添加成功',
                    type: 'success'
                });
                this.loadingData();
                this.addData = {};
                this.isAddDialog = false;
            }

        },
        async deletePetShop(row){

            this.$confirm('将删除此数据, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.deletePetShopFun(row.id);
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                });          
            });


            
        },
        async deletePetShopFun(id){
            let res  = await api.collectPetDelete(id);
            console.log(res);
            if(res.data.code == '200') {
                this.$message({
                    message: '删除成功',
                    type: 'success'
                });
                this.loadingData();
                this.isAddDialog = false;
            }
        },
        async updateshop(){
            for(let index in this.updateData.projectPrices){
                this.updateData.projectPrices[index].price = parseFloat(this.updateData.projectPrices[index].price?this.updateData.projectPrices[index].price:0)
            }
            this.updateData.shopLog = JSON.stringify(this.picList1);
            this.updateData.jyzz = JSON.stringify(this.picList2);
            this.updateData.jyxm = JSON.stringify(this.picList3);
            let res  = await api.collectPetUpdate(this.updateData);
            console.log(res);
            if(res.data.code == '200') {
                this.$message({
                    message: '编辑成功',
                    type: 'success'
                });
                this.loadingData();
                this.isUpdateDialog = false;
            }

        },
        isUpdateDialogShow(row){
            this.title = '编辑';
            this.isShow = true;
            this.isUpdateDialog = true;
            this.updateData = row;
            this.addressList = this.updateData.addressCode.split(',');
            this.picList1 = JSON.parse(this.updateData.shopLog?this.updateData.shopLog:'[]')
            this.picList2 = JSON.parse(this.updateData.jyzz?this.updateData.jyzz:'[]')
            this.picList3 = JSON.parse(this.updateData.jyxm?this.updateData.jyxm:'[]')
        },
        deleteXM(index){
            this.updateData.projectPrices.splice(index);
        },
        handleAddRegionChange(codeArray){
            if(codeArray[0]){
                this.updateData.province = CodeToText[codeArray[0]]
                this.updateData.addressCode = codeArray[0]
            }
            if(codeArray[1]){
                this.updateData.city = CodeToText[codeArray[1]]
                this.updateData.addressCode = this.updateData.addressCode + ',' + codeArray[1]
            }
            if(codeArray[2]){
                this.updateData.area = CodeToText[codeArray[2]]
                this.updateData.addressCode = this.updateData.addressCode + ',' + codeArray[2]
            }
        },
        async downloadExcel(){
            let res = await api.exportInventory({
                "type": 11,
                "Condition":{
                    "petShop":this.conditionData.petShop,
                    "pageSize":10000,
                }
                
            },'宠物店资料收集');
        },
    }
    
}
</script>

<style lang="scss" scoped>
    .condition{
        background-color: #ffffff;
        display: flex;
        align-items: center;
        border-radius: 5px;
        padding: 15px;
        font-size: 14px;
        .item{
            display: flex;
            align-items: center;
            .label{
                min-width: 80px;
                margin-left: 15px;
            }
        }
        .btns{
            margin-left: 20px;
        }
    }
    .table{
        margin-top: 10px;
        background-color: #ffffff;
        padding: 15px;
        .handle{
            width: 100%;
            display: flex;
            justify-content: space-between;
            padding-bottom: 15px;
            align-items: center;
            font-size: 20px;
        }
        .page{
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-top: 16px;
            .el-pagination{
                margin-left: -10px;
            }
        }
    }

    .dialog{
        padding-top: 20px;
        height: 100%;
        display: flex;
        flex-wrap: wrap;
        .item{
            font-size: 14px;
            padding:10px 15px;
            display: flex;
            align-items: center;
            flex-wrap: wrap;
            .label{
                width: 150px;
                margin-bottom: 5px;
            }
            .value{
                width: 215px;
            }
            .label-pic{
                width: 600px;
                display: flex;
                align-items: center;
                span{
                    color: red;
                    font-size: 20px;
                    margin: 0 4px;
                    margin-top: 2px;
                }
            }
            .pics{
                width: 100%;
                display: flex;
                flex-wrap: wrap;
                align-items: center;
                margin-top: 10px;
                .pics-item{
                    width: 120px;
                    height: 120px;
                    position: relative;
                    margin-right: 10px;
                    margin-left: 10px;
                    .pics-item-img{
                        width: 120px;
                        height: 120px;
                    }
                    .close{
                        position: absolute;
                        top: -12px;
                        right: -12px;
                        width: 24px;
                        height: 24px;
                    }
                }
                .chooseimg{
                    margin-right: 10px;
                    margin-left: 10px;
                }
                img{
                    width: 120px;
                    height: 120px;
                    margin: 0;
                    margin-bottom: 20px;
                }
            }
        }
        
        .dialog-footer{
            width: 100%;
            display: flex;
            padding:10px 15px;
            flex-direction: row-reverse;
            .el-button{
                margin-left: 20px;
            }
        }
    }
</style>
